import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = { class: "footerFixed" };
const _hoisted_2 = {
    id: "all_wrapper",
    class: "index"
};
const _hoisted_3 = { class: "fv" };
const _hoisted_4 = { class: "inner" };
const _hoisted_5 = { class: "wrapper_1 home-wrapper" };
const _hoisted_6 = { class: "inner2 home-inner" };
const _hoisted_7 = { class: "sec1" };
const _hoisted_8 = { class: "step" };
const _hoisted_9 = { class: "sec2" };
const _hoisted_10 = { class: "sec3" };
const _hoisted_11 = { class: "inner" };
const _hoisted_12 = { class: "title" };
const _hoisted_13 = { class: "title" };
const _hoisted_14 = { class: "title" };
const _hoisted_15 = { class: "title" };
const _hoisted_16 = { class: "title" };
const _hoisted_17 = { class: "plate" };
const _hoisted_18 = { class: "sec4" };
const _hoisted_19 = { class: "sec5" };
const _hoisted_20 = { class: "inner" };
const _hoisted_21 = { class: "price_box" };
const _hoisted_22 = { class: "title" };
const _hoisted_23 = { class: "t1" };
const _hoisted_24 = { class: "price" };
const _hoisted_25 = { class: "t2" };
const _hoisted_26 = { class: "t3" };
const _hoisted_27 = { class: "bt_box" };
const _hoisted_28 = ["onClick"];
import { Link } from '@inertiajs/inertia-vue3';
import headerVue from '@layout/header.vue';
import footerVue from '@layout/footer.vue';
import ImageFrame from '@component/ImageFrame.vue';
import { PlanCategory, UserType } from '@util/Consts';
import InertiaUtil from '@util/InertiaUtil';
export default /*@__PURE__*/ _defineComponent({
    __name: 'index',
    props: {
        common: {},
        mentor_count: {},
        question_count: {},
        plans: {}
    },
    setup(__props) {
        const props = __props;
        const showMonthlyAmount = (id, amount) => {
            if (id === PlanCategory.FREE_PLAN) {
                return '無料';
            }
            else if (amount) {
                return `${amount.toLocaleString()}円/月`;
            }
            return '';
        };
        const showQuestionCount = (id, count) => {
            if (id === PlanCategory.FREE_PLAN) {
                return '相談は不可';
            }
            else {
                return `${count}件以内/月`;
            }
        };
        const showAddQuestionAmount = (id, amount) => {
            if (id === PlanCategory.FREE_PLAN) {
                return 'ー';
            }
            else if (amount) {
                return `${amount.toLocaleString()}円/件`;
            }
            return '';
        };
        const onClickSignUp = (planId) => {
            const form = InertiaUtil.getForm({
                type: UserType.QUESTIONER,
                plan_id: planId,
            });
            form.get(route('signup'));
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _createVNode(headerVue, {
                    common: props.common
                }, null, 8, ["common"]),
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("div", _hoisted_4, [
                                _cache[0] || (_cache[0] = _createElementVNode("div", { class: "p_1" }, [
                                    _createTextVNode(" 多業種・多様な経験を持ったメンターが、総力で"),
                                    _createElementVNode("br", { class: "pc2" }),
                                    _createTextVNode("あなたのビジネスに関する困りごとを解決します。 ")
                                ], -1)),
                                _cache[1] || (_cache[1] = _createElementVNode("div", { class: "p_2" }, [
                                    _createTextVNode("中小企業経営者向けの定額クラウド・ビジネス相談窓口"),
                                    _createElementVNode("br"),
                                    _createTextVNode("「ShareMentors」")
                                ], -1)),
                                _createVNode(ImageFrame, { src: "images/index/i_fv.png" })
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("div", _hoisted_6, [
                                _createElementVNode("div", _hoisted_7, [
                                    _cache[3] || (_cache[3] = _createElementVNode("h3", null, "ShareMentors とは？", -1)),
                                    _cache[4] || (_cache[4] = _createElementVNode("p", null, [
                                        _createTextVNode(" 中小企業のビジネス課題に、様々な経験者が応えます。"),
                                        _createElementVNode("br"),
                                        _createTextVNode(" ビジネスに関する困りごとを、web上で質問投稿すると厳選された多業種・多様な経験者がすぐに回答してくれる仕組みです。ひとりの回答でなく、複数メンターの回答を得ることができるので最適な判断につながります。更に、公開されたQ＆Aの内容を参照することによっても知見を得ることができます。"),
                                        _createElementVNode("br"),
                                        _createElementVNode("br"),
                                        _createTextVNode(" 個人事業主や小規模の中小企業には、IT・マーケティングなど専門部門がなくて代表者が代行されているケースが多いですが、それを補完できるサービスを目的としています。"),
                                        _createElementVNode("br"),
                                        _createTextVNode(" ビジネス上の様々な疑問について気軽に相談ができて、中小企業の成長に貢献できることを目指しています。"),
                                        _createElementVNode("br")
                                    ], -1)),
                                    _createElementVNode("ul", _hoisted_8, [
                                        _createElementVNode("li", null, [
                                            _createVNode(ImageFrame, { src: "images/index/sec1_1.png" })
                                        ]),
                                        _createElementVNode("li", null, [
                                            _createVNode(ImageFrame, {
                                                class: "pc",
                                                src: "images/index/sec1_2.png"
                                            }),
                                            _createVNode(ImageFrame, {
                                                class: "sp",
                                                src: "images/index/sec1_2_sp.png"
                                            })
                                        ]),
                                        _createElementVNode("li", null, [
                                            _createVNode(ImageFrame, { src: "images/index/sec1_3.png" }),
                                            _createVNode(_unref(Link), {
                                                href: _ctx.route('mentor.home')
                                            }, {
                                                default: _withCtx(() => _cache[2] || (_cache[2] = [
                                                    _createTextVNode("私も回答したいという方はこちら")
                                                ])),
                                                _: 1,
                                                __: [2]
                                            }, 8, ["href"])
                                        ])
                                    ])
                                ]),
                                _cache[35] || (_cache[35] = _createElementVNode("div", { class: "sec1" }, [
                                    _createElementVNode("h3", null, "ShareMentors の相談分野"),
                                    _createElementVNode("p", null, "ＩＴ系を中心に次のような職種の専門家に相談できます。"),
                                    _createElementVNode("ul", { class: "category" }, [
                                        _createElementVNode("li", null, "・経営/事業"),
                                        _createElementVNode("li", null, "・マーケ/広報"),
                                        _createElementVNode("li", null, "・営業"),
                                        _createElementVNode("li", null, "・販売/サービス"),
                                        _createElementVNode("li", null, "・ITエンジニア"),
                                        _createElementVNode("li", null, "・クリエイター")
                                    ])
                                ], -1)),
                                _createElementVNode("div", _hoisted_9, [
                                    _cache[5] || (_cache[5] = _createElementVNode("h3", null, "ShareMentors の相談ケース", -1)),
                                    _cache[6] || (_cache[6] = _createElementVNode("p", null, "次のようなことでお困りの方に向けたサービスです。", -1)),
                                    _createVNode(ImageFrame, {
                                        class: "pc",
                                        src: "images/index/sec2_pc.jpg"
                                    }),
                                    _createVNode(ImageFrame, {
                                        class: "sp",
                                        src: "images/index/sec2_sp.jpg"
                                    })
                                ]),
                                _createElementVNode("div", _hoisted_10, [
                                    _createElementVNode("div", _hoisted_11, [
                                        _cache[23] || (_cache[23] = _createElementVNode("h3", null, "ShareMentors の特長", -1)),
                                        _cache[24] || (_cache[24] = _createElementVNode("p", null, "相談者にとって、次のような特長・メリットがあります。", -1)),
                                        _createElementVNode("ul", null, [
                                            _createElementVNode("li", null, [
                                                _cache[8] || (_cache[8] = _createElementVNode("div", { class: "no" }, "1", -1)),
                                                _createElementVNode("div", _hoisted_12, [
                                                    _cache[7] || (_cache[7] = _createElementVNode("div", { class: "t_1" }, "複数名の回答", -1)),
                                                    _createVNode(ImageFrame, { src: "images/index/icon_1.svg" })
                                                ]),
                                                _cache[9] || (_cache[9] = _createElementVNode("div", { class: "account" }, " １対１のメンターではなく、一度に複数のメンターから回答を得ることができるので、最適な判断につながります。 ", -1))
                                            ]),
                                            _createElementVNode("li", null, [
                                                _cache[11] || (_cache[11] = _createElementVNode("div", { class: "no" }, "2", -1)),
                                                _createElementVNode("div", _hoisted_13, [
                                                    _cache[10] || (_cache[10] = _createElementVNode("div", { class: "t_1" }, "回答の質が高い", -1)),
                                                    _createVNode(ImageFrame, { src: "images/index/icon_2.svg" })
                                                ]),
                                                _cache[12] || (_cache[12] = _createElementVNode("div", { class: "account" }, " 不特定多数の回答者ではなく、厳選されたメンターが登録されており、かつ過去の回答状況・評価も分かります。 ", -1))
                                            ]),
                                            _createElementVNode("li", null, [
                                                _cache[14] || (_cache[14] = _createElementVNode("div", { class: "no" }, "3", -1)),
                                                _createElementVNode("div", _hoisted_14, [
                                                    _cache[13] || (_cache[13] = _createElementVNode("div", { class: "t_1" }, "回答が早い", -1)),
                                                    _createVNode(ImageFrame, { src: "images/index/icon_3.svg" })
                                                ]),
                                                _cache[15] || (_cache[15] = _createElementVNode("div", { class: "account" }, " 毎回詳しい人を探す必要がありません。クラウド・サービスなので短時間に回答を得ることができます。 ", -1))
                                            ]),
                                            _createElementVNode("li", null, [
                                                _cache[17] || (_cache[17] = _createElementVNode("div", { class: "no" }, "4", -1)),
                                                _createElementVNode("div", _hoisted_15, [
                                                    _cache[16] || (_cache[16] = _createElementVNode("div", { class: "t_1" }, "安価", -1)),
                                                    _createVNode(ImageFrame, { src: "images/index/icon_4.svg" })
                                                ]),
                                                _cache[18] || (_cache[18] = _createElementVNode("div", { class: "account" }, " 複数分野の士業、コンサルタント、専門家と契約するよりは安価にご利用できます。 ", -1))
                                            ]),
                                            _createElementVNode("li", null, [
                                                _cache[20] || (_cache[20] = _createElementVNode("div", { class: "no" }, "5", -1)),
                                                _createElementVNode("div", _hoisted_16, [
                                                    _cache[19] || (_cache[19] = _createElementVNode("div", { class: "t_1" }, "ナレッジ共有", -1)),
                                                    _createVNode(ImageFrame, { src: "images/index/icon_5.svg" })
                                                ]),
                                                _cache[21] || (_cache[21] = _createElementVNode("div", { class: "account" }, " 公開された他者の相談と回答を参照することによっても知見を得ることができます。 ", -1))
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_17, [
                                            _cache[22] || (_cache[22] = _createElementVNode("h4", null, "他サービスとの比較", -1)),
                                            _createVNode(ImageFrame, { src: "images/index/sec4.jpg" })
                                        ])
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_18, [
                                    _cache[25] || (_cache[25] = _createElementVNode("h3", null, "相談イメージ", -1)),
                                    _cache[26] || (_cache[26] = _createElementVNode("div", { class: "step" }, [
                                        _createElementVNode("div", { class: "no" }, "1"),
                                        _createElementVNode("p", null, "相談と回答･･･チャット方式で相談者は各メンターとQ＆A")
                                    ], -1)),
                                    _createVNode(ImageFrame, { src: "images/index/sec5_1.jpg" }),
                                    _cache[27] || (_cache[27] = _createElementVNode("div", { class: "step" }, [
                                        _createElementVNode("div", { class: "no" }, "2"),
                                        _createElementVNode("p", null, "相談終了…相談者によるランキングとコメント入力")
                                    ], -1)),
                                    _createVNode(ImageFrame, { src: "images/index/sec5_2.jpg" })
                                ]),
                                _createElementVNode("div", _hoisted_19, [
                                    _createElementVNode("div", _hoisted_20, [
                                        _cache[33] || (_cache[33] = _createElementVNode("h3", null, "料金プラン", -1)),
                                        _createElementVNode("ul", _hoisted_21, [
                                            _cache[32] || (_cache[32] = _createStaticVNode("<li><div class=\"title\"> </div><div class=\"t1\"><p>基本料金</p></div><div class=\"t2\"><p>相談回数</p></div><div class=\"t3\"><p>追加相談</p></div><div class=\"t4\"><p>公開Q＆A閲覧</p></div><div class=\"bt_box\"></div></li>", 1)),
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.plans, (option) => {
                                                return (_openBlock(), _createElementBlock("li", null, [
                                                    _createElementVNode("div", _hoisted_22, _toDisplayString(option.name), 1),
                                                    _createElementVNode("div", _hoisted_23, [
                                                        _cache[28] || (_cache[28] = _createElementVNode("p", { class: "tt" }, "基本料金", -1)),
                                                        _createElementVNode("p", _hoisted_24, _toDisplayString(showMonthlyAmount(option.id, option.monthly_amount)), 1)
                                                    ]),
                                                    _createElementVNode("div", _hoisted_25, [
                                                        _cache[29] || (_cache[29] = _createElementVNode("p", { class: "tt" }, "相談回数", -1)),
                                                        _createTextVNode(" " + _toDisplayString(showQuestionCount(option.id, option.monthly_question_count)), 1)
                                                    ]),
                                                    _createElementVNode("div", _hoisted_26, [
                                                        _cache[30] || (_cache[30] = _createElementVNode("p", { class: "tt" }, "追加相談", -1)),
                                                        _createTextVNode(" " + _toDisplayString(showAddQuestionAmount(option.id, option.additional_question_amount)), 1)
                                                    ]),
                                                    _cache[31] || (_cache[31] = _createElementVNode("div", { class: "t4" }, [
                                                        _createElementVNode("p", { class: "tt" }, "公開Q＆A閲覧"),
                                                        _createTextVNode(" 無制限 ")
                                                    ], -1)),
                                                    _createElementVNode("div", _hoisted_27, [
                                                        _createElementVNode("a", {
                                                            class: "bt",
                                                            onClick: _withModifiers(($event) => (onClickSignUp(option.id)), ["prevent"]),
                                                            style: { "cursor": "pointer" }
                                                        }, "今すぐ登録", 8, _hoisted_28)
                                                    ])
                                                ]));
                                            }), 256))
                                        ]),
                                        _cache[34] || (_cache[34] = _createElementVNode("div", { class: "under" }, [
                                            _createElementVNode("p", null, "※表示価格はすべて税込です。"),
                                            _createElementVNode("p", null, "※1つの相談に対してQ＆Aが繰り返され、終了が確定するまでを１件（１チケット）とします。"),
                                            _createElementVNode("p", null, "※初月の基本料金は、申込日に応じて次の対応とさせて頂きます。"),
                                            _createElementVNode("p", null, "　・申込日が1～15日：基本料金を全額支払い（相談回数は基本と同数）"),
                                            _createElementVNode("p", null, "　・申込日が16～末日：基本料金を半額支払い（相談回数は基本の半数）")
                                        ], -1))
                                    ])
                                ]),
                                _cache[36] || (_cache[36] = _createStaticVNode("<div class=\"sec6\"><h3>よくあるご質問</h3><h4>契約・申込</h4><ul class=\"faq\"><li>最小契約期間は？</li><li>１カ月です。日割り計算は行いません。</li><li>できれば自身や自社の情報を公開したくないのですが？</li><li>表示名、業種は必須で公開表示されますが、会社情報や本名は任意です。</li><li>回答に対してどこまで責任を持っていますか？</li><li> 当社、およびメンターは相談の回答に従って生じた損害について責任を負いません。ただし、当社はスキルとコミュニケーション能力の高いメンターを確保することに尽力します。 </li></ul><h4>相談・回答</h4><ul class=\"faq\"><li>回答が１件も無かった場合は？</li><li>相談１件としてカウントされません。</li><li>満足いく回答が無かった場合は？</li><li>回答が１件でもあれば、相談１件としてカウントされます。（課金されます）</li><li>ビデオ会議には対応していますか？</li><li>現状はチャット方式のみです。</li></ul><h4>決済</h4><ul class=\"faq\"><li>支払い方法は？</li><li>クレジットカードによるお支払い（VISA/Master/JCB/AMEX）となります。</li></ul></div>", 1))
                            ])
                        ])
                    ]),
                    _createVNode(footerVue)
                ])
            ]));
        };
    }
});
